<mat-nav-list>
  <mat-list-item *ngFor="let item of menuItems" routerLink={{item.link}}>
    <i *ngIf="item.type === 'badge' && openOccurrence !== '0'" matBadge="{{openOccurrence}}" matBadgeColor="warn" class="fa" ngClass={{item.icon}}></i>
    <i *ngIf="item.type !== 'badge' || openOccurrence === '0'" class="fa" ngClass={{item.icon}}></i>
    <div class="mat-nav-list-text">{{ item.name | translate}}</div>
  </mat-list-item>
</mat-nav-list>
